<template>
  <div class="page">
    <div class="title-box">
      <div class="title">我要办活动</div>
    </div>
    <div class="list">
      <div
        class="item"
        @click="navTo(item.id)"
        v-for="item in list"
        :key="item.id"
      >
        <div class="top">
          <div class="icon"></div>
          <div class="title">{{ item.title }}</div>
        </div>
        <div class="content">
          {{ item.content }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Img from "../workdetails/components/img";
// const icon_1 = require("../assets/images/sub_1.png");

export default {
  data() {
    return {
      list: [
        {
          title: "素材库制作图片素材",
          id: 1,
          content:
            "活动云平台内置强大的可视化图片编辑器，助力机构快速设计出需要的设计稿，通过替换修改文字就能够完成图片设计。",
        },
        {
          title: "案例库引用相符案例",
          id: 2,
          content:
            "活动云平台提供千余种活动案例，助力机构免去文案编写，一键引用相符案例，通过修改部分文案就可完成活动的文字说明。",
        },
        {
          title: "一键发布活动至多终端",
          id: 3,
          content:
            "你可以通过点击一键发布按钮，将配置的活动同步至pc端、微信端，多终端只需一次配置。",
        },
        {
          title: "作品审核及优秀作品评选",
          id: 4,
          content:
            "你可以对参赛作品进行审核，审核通过的作品可以进入优秀作品评审页。你可以在已通过审核的作品中筛选出优秀作品，并进行相应奖励发放。",
        },
        {
          title: "可为活动获奖读者颁发电子证书",
          id: 5,
          content:
            "可通过语林鸟电子证书管理系统，实现该活动下电子证书的生成、核发、校验、管理等功能，获奖读者的电子证书可在个人中心进行实时查看和",
        },
        {
          title: "活动数据查看及数据导出",
          id: 6,
          content:
            "活动云平台提供丰富的活动数据以及作品数据，可以一键追溯历史数据以及批量导出数据，供活动方分析数据。",
        },
      ],
    };
  },
  methods: {
    navTo(num) {
      switch (num) {
        // 素材库
        case 1:
          window.open("https://www.yulin365.net/manage/home/material-lib");
          break;
        case 2:
          // 案例库
          // window.open("https://www.yulin365.net/backend/activity/example/index")
          window.open(`https://www.yulin365.net/manage/home/case-lib`);
          break;
        case 3:
          // 我要办活动
          // window.open("https://www.yulin365.net/backend/activity/activity/edit")
          window.open(`https://www.yulin365.net/manage/home/activity`);
          break;
        case 4:
          // 作品管理
          // window.open('https://www.yulin365.net/backend/activity/activity-works/list')
          window.open(`https://www.yulin365.net/manage/home/activity`);
          break;
        case 5:
          // 证书
          // window.open('https://www.yulin365.net/backend/main/system_jg')
          window.open(`https://www.yulin365.net/manage/home/award-certificate`);
          break;
        case 6:
          // 整理数据
          // window.open('https://www.yulin365.net/backend/main/system_jg')
          window.open(`https://www.yulin365.net/manage/home/statistics`);
          break;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.page {
  width: 1200px;
  margin: 0 auto;
  font-size: 15px;
  .title-box {
    display: flex;

    .title {
      font-weight: bold;
      font-size: 23px;
      position: relative;
      height: 40px;
      &::after {
        content: "";
        display: flex;
        position: absolute;
        bottom: 0px;
        left: 0;
        width: 100%;
        height: 4px;
        border-radius: 2px;
        background-color: #3370ff;
      }
    }
  }
  .list {
    margin: 30px 0;
    display: flex;
    flex-wrap: wrap;
    .item {
      width: calc((100% - 60px) / 3);
      margin: 0 30px 20px 0;
      display: flex;
      flex-direction: column;
      background-color: #fff;
      padding: 30px 30px;
      box-sizing: border-box;
      background-size: 100% 100%;
      background-repeat: no-repeat;
      cursor: pointer;
      .top {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        .icon {
          width: 30px;
          height: 30px;
          margin-right: 10px;
          // background-color: #f40;
          background-size: contain;
          background-repeat: no-repeat;
        }
        .title {
          font-style: 18px;
          font-weight: bold;
        }
      }
      .content {
        height: 100px;
        font-size: 14px;
        line-height: 1.6;
        margin-right: 100px;
        color: #999;
        // background: #3370ff;
      }
      &:nth-child(1) {
        background: url("../assets/images/banner_1_bg.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
        .icon {
          background-image: url("../assets/images/sub_1.png");
        }
      }
      &:nth-child(2) {
        background: url("../assets/images/banner_2_bg.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
        .icon {
          background-image: url("../assets/images/sub_2.png");
        }
      }
      &:nth-child(3) {
        background: url("../assets/images/banner_3_bg.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
        .icon {
          background-image: url("../assets/images/sub_3.png");
        }
      }
      &:nth-child(4) {
        background: url("../assets/images/banner_4_bg.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
        .icon {
          background-image: url("../assets/images/sub_4.png");
        }
      }
      &:nth-child(5) {
        background: url("../assets/images/banner_5_bg.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
        .icon {
          background-image: url("../assets/images/sub_5.png");
        }
      }
      &:nth-child(6) {
        background: url("../assets/images/banner_6_bg.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
        .icon {
          background-image: url("../assets/images/sub_6.png");
        }
      }

      //
      &:nth-child(1):hover {
        background: url("../assets/images/banner_1_bg_active.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
        color: #fff;
        .content {
          color: #fff;
        }
        .icon {
          background-image: url("../assets/images/sub_1_active.png");
        }
      }
      &:nth-child(2):hover {
        background: url("../assets/images/banner_2_bg_active.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
        color: #fff;
        .content {
          color: #fff;
        }
        .icon {
          background-image: url("../assets/images/sub_2_active.png");
        }
      }
      &:nth-child(3):hover {
        background: url("../assets/images/banner_3_bg_active.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
        color: #fff;
        .content {
          color: #fff;
        }
        .icon {
          background-image: url("../assets/images/sub_3_active.png");
        }
      }
      &:nth-child(4):hover {
        background: url("../assets/images/banner_4_bg_active.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
        color: #fff;
        .content {
          color: #fff;
        }
        .icon {
          background-image: url("../assets/images/sub_4_active.png");
        }
      }
      &:nth-child(5):hover {
        background: url("../assets/images/banner_5_bg_active.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
        color: #fff;
        .content {
          color: #fff;
        }
        .icon {
          background-image: url("../assets/images/sub_5_active.png");
        }
      }
      &:nth-child(6):hover {
        background: url("../assets/images/banner_6_bg_active.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
        color: #fff;
        .content {
          color: #fff;
        }
        .icon {
          background-image: url("../assets/images/sub_6_active.png");
        }
      }

      &:nth-child(3n) {
        margin: 0 0 20px 0;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/organizeEvents.vue